import {useState,useEffect,useRef} from "react";
import {Link} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../../../core/img";
import {all_routes} from "../../../router/all_routes";
import Table from "../../../../core/dataTable/index";
import Modal_Item_Add from "../item/modalItemAdd";
import {Toaster} from 'react-hot-toast';
// -- biz9 --
import {Str} from "biz9-utility";
import {Portal_Url,Portal_Table,Portal_Type,Portal_Remote_Data,Portal_Remote_Image,Portal_Remote_CMS} from "biz9-portal-app";
import {Image_Format} from "biz9-image";
import {Message,Type,Title,Config} from "../../../../constant";
import {Data,Image,Style,Toast_Message,App} from "../../../../project";
import {Data_Logic} from "biz9-data-app";
const Dashboard_App_Faq = () => {
    const timeoutRef = useRef(null);
    const [val_sub_page_title,setValSubPageTitle] = useState(Str.get_table_by_name(Portal_Table.FAQ,{plural:true}));
    const [faqs,setFaqs] = useState([]);
    // -- paging --
    const [val_page_current,setValPageCurrent] = useState(Type.PAGE_CURRENT);
    const [val_page_size,setValPageSize] = useState(Type.PAGE_SIZE);
    const [val_total,setValTotal] = useState(0);
    const [val_filter,setValFilter] = useState({});
    const [val_sort_by,setValSortBy] = useState({});
    const [val_option,setValOption] = useState({});

   const columns = [
    {
title: "Title",
           dataIndex: "title",
           key: "title",
           render: (text: string, record: any) => (
                   <h2 className="table-avatar d-flex align-items-center">
                   <Link to={all_routes.dashboard_app_faq_edit+"?id="+record.id} className="avatar">
                   <ImageWithBasePath src={Image.get_url(record.image_filename,Image_Format.SQUARE_THUMB)} />
                   </Link>
                   <Link to={all_routes.dashboard_app_faq_edit+"?id="+record.id} className="text-dark">
                   {record.title}
                   </Link>
                   </h2>
                   ),
           sorter: true
    },
    {
title: "Action",
       dataIndex: "action",
       render: (res: string, record: any) => (
               <>
               <div className="dropdown dropdown-action">
               <Link to="#" className="action-icon" data-bs-toggle="dropdown" aria-expanded="false">
               <FeatherIcon icon="more-vertical" />
               </Link>
               <div className="dropdown-menu dropdown-menu-right">
               <Link className="dropdown-item" to="#" onClick={(e) => { {btn_post_copy(record.id)} }} >
               <FeatherIcon icon="copy" /> Copy
               </Link>
               <Link className="dropdown-item" to="#" onClick={(e) => { {btn_post_delete(record.id)} }} >
               <FeatherIcon icon="trash" /> Delete
               </Link>
               </div>
               </div>
               </>
               ),
    },
    ];
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            get_data();
            if(timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            }
            },[]);
    async function get_data() {
        let search = Data_Logic.get_search(Portal_Table.FAQ,val_filter,{page_current:val_page_current,page_size:val_page_size});
        let [response,data] = await Portal_Remote_CMS.search(App.get_url(Portal_Url.DATA_SEARCH),search,{category:Portal_Table.FAQ});
        bind_items(data);
        Toast_Message.dismiss();
    };
    async function bind_items(data){
        setFaqs(data.items);
        setValTotal(data.item_count);
    };
    async function btn_post_copy(id: any) {
        Toast_Message.loading(Message.SAVING);
        let [response,data] = await Portal_Remote_Data.copy(App.get_url(Portal_Url.DATA_COPY),Portal_Table.FAQ,id);
        setFaqs([data, ...faqs]);
        Toast_Message.success(response.message);
    };
    async function btn_post_delete(id: any) {
        if(window.confirm(Message.CONFIRM)){
            Toast_Message.loading(Message.DELETING);
            let [response,data] = await Portal_Remote_Data.delete(App.get_url(Portal_Url.DATA_DELETE),Portal_Table.FAQ,id);
            setFaqs(faqs.filter(item=>item.id!==id));
            Toast_Message.success(response.message);
        }
    };
    const updateNewItem = (item) => {
        setFaqs([item, ...faqs]);
    };
    return (
            <>
            <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="container px-0">
            {/*Inner Content */}
            <div className="content mx-4 mb-4">
            <div className="main-title my-4">
            <h4>{val_sub_page_title}</h4>
            </div>
            <div className="wallet-wrap">
            <div className="wallet-list">
            <div className="wallet-item mt-10">
            </div>
            </div>
            <div className="d-flex align-items-center">
            <Link to="#" data-bs-toggle="modal" data-bs-target="#withdraw" className="btn btn-primary">
            Add
            </Link>
            </div>
            </div>
            <div className="table-responsive custom-table">
            <Table onUpdate={setFaqs} allow_multiple={true}  page_size={val_page_size} page_current={val_page_current} total={val_total} option={val_option} sort_by={val_sort_by} filter={val_filter} table={Portal_Table.FAQ} dataSource={faqs} columns={columns} Selection={false} />

            </div>
            <div className="table-footer">
            <div id="tablepage" />
            </div>
            </div>
            {/* /Inner Content */}
    </div>
        </div>
        {/* /Page Content */}
    <Modal_Item_Add toast_loading={Toast_Message.loading} toast_success={Toast_Message.success} toast_error={Toast_Message.error} toast_dismiss={Toast_Message.dismiss} onUpdate={updateNewItem} table={Portal_Table.FAQ}/>
        </>
        );
};
export default Dashboard_App_Faq ;
